export type ServiceInfoModel = {
  name: string;
  description: string;
  priceAmount: string;
  priceUnit?: string;
  icon: string;
  tag?: string;
  tags?: string[];
  rating?: number;
};

interface ServiceInfoProps {
  service: ServiceInfoModel;
}

export default function ServiceInfo({ service }: ServiceInfoProps) {
  const rating = service.rating ?? 5;
  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      <div className="p-6">
        <div className="flex items-start space-x-5">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 bg-gray-50 rounded-2xl border border-gray-100 flex items-center justify-center">
              <img
                src={service.icon}
                alt={service.name}
                className="w-12 h-12 object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">{service.name}</h1>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-3 py-1 text-sm font-medium bg-green-100 text-green-700 rounded-full">
                    服务中
                  </span>
                  {service.tag && (
                    <span className="px-3 py-1 text-sm font-medium bg-red-50 text-red-500 rounded-full">
                      {service.tag}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center space-x-1 flex-shrink-0 ml-4">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-sm" />
                </div>
                <span className="text-base font-semibold text-gray-900">{rating}</span>
                <span className="text-gray-400 text-sm">(99+)</span>
              </div>
            </div>
            <p className="text-gray-600 text-base leading-relaxed mb-4">{service.description}</p>
            <div className="mb-4">
              <div className="flex items-baseline space-x-1">
                <span className="text-3xl font-bold text-red-500">{service.priceAmount}</span>
                <span className="text-sm text-gray-400">{service.priceUnit || 'U'}</span>
                <span className="text-sm text-gray-400">起</span>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {(service.tags || []).map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 bg-gray-100 text-gray-600 text-sm rounded-full hover:bg-gray-200 transition-colors cursor-pointer"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
